import React from 'react'

interface IProps {
  prod: boolean
}

export const ErrorContainer: React.FC<IProps> = ({
  children,
  prod = false,
}) => {
  if (prod) {
    const ProductionErrorBoundary = require('react-error-guard/lib/ProductionErrorBoundary')
      .default
    return <ProductionErrorBoundary>{children}</ProductionErrorBoundary>
  } else {
    const DeveloperErrorBoundary = require('react-error-guard/lib/DeveloperErrorBoundary')
      .default
    return <DeveloperErrorBoundary>{children}</DeveloperErrorBoundary>
  }
}
